import { useState } from "react";
import { Form as AntdForm, message } from "antd";
import { Modal, Form } from "../..";
import { USER_CAR_FORM } from "../../../data/forms";
import { IsEnable } from "../../../enums";

// Хэрэглэгч өөрөө машинаа нэмэх / засах modal.
// car байхгүй бол шинээр нэмнэ, байвал тухайн машины мэдээллийг засна.
export const USER_CAR_URL = "/user/addeditcar";

const Index = ({ open, onClose, car, ...props }) => {
  const [form] = AntdForm.useForm();
  const [loading, setLoading] = useState(false);
  const isEdit = !!car?.id;

  const initialValues = isEdit
    ? {
        id: car?.id,
        name: car?.name,
        number: car?.number,
        type: car?.type,
        imei: car?.imei,
        iskey: car?.iskey,
        operator: car?.operator,
      }
    : { id: 0 };

  const handleSave = (values) => {
    if (props?._auth?.user?.phone === "demo") {
      message.error(props?.translate("main.democontrol"));
      return;
    }
    const body = {
      ...values,
      imei: values?.imei?.toString()?.trim(),
      // Админаас тохируулдаг талбарууд: засахдаа хуучин утгыг нь хадгална
      isnewbroker: isEdit ? (car?.isnewbroker ?? 1) : 1,
      islock: isEdit ? (car?.islock ?? 0) : 0,
      ismotor: isEdit ? (car?.ismotor ?? 0) : 0,
      isenable: IsEnable.Идэвхтэй,
    };
    setLoading(true);
    props
      ?.request({
        url: USER_CAR_URL,
        method: "POST",
        body,
        ismessage: true,
      })
      ?.then((res) => {
        setLoading(false);
        if (res?.success) {
          props?.request({
            url: `/user/cars`,
            model: "carsinfo",
            method: "POST",
          });
          form.resetFields();
          onClose && onClose(res?.data);
        }
      });
  };

  return (
    <Modal
      title={props?.translate(isEdit ? "main.editcar" : "main.addcar")}
      open={open}
      onClose={onClose}
      width={600}
      isShowFooter={false}
      height={"85%"}
    >
      {open ? (
        <Form
          {...props}
          key={isEdit ? car?.id : "new"}
          name="usercar"
          data={USER_CAR_FORM}
          form={form}
          loading={loading}
          handleSave={handleSave}
          initialValues={initialValues}
          className="mt-2"
          btnTitle="main.save"
        />
      ) : null}
    </Modal>
  );
};

export default Index;
